/**
 * Interpreta schema_json da API (objeto ou string). Suporta legado em que o backend
 * gravava JSON.stringify em cima de string já serializada (dupla serialização).
 *
 * @param {string|object|Array|null|undefined} raw
 * @returns {{ rows?: unknown[], headerWidgets?: unknown[], globalConfig?: object } & Record<string, unknown>}
 */
export function parseLayoutSchemaJson(raw) {
    if (raw == null || raw === '') return { rows: [] };
    let schema = raw;
    if (typeof schema === 'string') {
        const t = schema.trim();
        if (!t) return { rows: [] };
        try {
            schema = JSON.parse(t);
        } catch {
            return { rows: [] };
        }
    }
    while (typeof schema === 'string') {
        try {
            schema = JSON.parse(schema);
        } catch {
            break;
        }
    }
    if (Array.isArray(schema)) return { rows: schema };
    if (schema && typeof schema === 'object') return schema;
    return { rows: [] };
}

/**
 * Normaliza o schema armazenado no banco para o mesmo formato aceito em
 * "Criar template a partir de JSON": objeto com rows; arrays legados viram { rows }.
 *
 * @param {string|object|Array} raw — schema_json do template
 * @returns {string} JSON indentado (2 espaços)
 */
export function normalizeLayoutSchemaForJsonExport(raw) {
    const schema = parseLayoutSchemaJson(raw);
    const normalized = { ...schema };
    if (!Array.isArray(normalized.rows)) normalized.rows = [];
    return JSON.stringify(normalized, null, 2);
}
